"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "generatePalette", {
  enumerable: true,
  get: function get() {
    return _Color.generatePalette;
  }
});
Object.defineProperty(exports, "getContrast", {
  enumerable: true,
  get: function get() {
    return _Color.getContrast;
  }
});
Object.defineProperty(exports, "hex2RGB", {
  enumerable: true,
  get: function get() {
    return _Color.hex2RGB;
  }
});
Object.defineProperty(exports, "hexToRGBA", {
  enumerable: true,
  get: function get() {
    return _Color.hexToRGBA;
  }
});
Object.defineProperty(exports, "rgb2Hex", {
  enumerable: true,
  get: function get() {
    return _Color.rgb2Hex;
  }
});
Object.defineProperty(exports, "isColor", {
  enumerable: true,
  get: function get() {
    return _Color.isColor;
  }
});

var _Color = require("./Color");